// ***************
// src/app/services/cryptosenha.js
// autor: WdePaula / MVinfo 
// data: 13/7/24 | 21h12
// ***************


import CryptoJS from 'crypto-js';

const criptKey = process.env.REACT_APP_CRIPTKEY;

// function encryptPassword(password, criptKey) {
export function encryptPass(password) {
    const encryptedPassword = CryptoJS.HmacSHA256(password, criptKey).toString(CryptoJS.enc.Hex);
    return encryptedPassword;
}

// // Exemplo de uso
// const password = 'senhaDoUsuario';
// const criptKey = process.env.REACT_APP_CRIPTKEY;

// const encryptedPassword = encryptPassword(password, criptKey);
// console.log('Senha criptografada:', encryptedPassword);



// import bcrypt from 'bcrypt';

// // Gerar um hash de senha
// bcrypt.hash((process.env.REACT_APP_CRIPTKEY), 10, (err, hash) => {
//   // hash é o hash da senha que você pode armazenar no banco de dados
//   console.log(hash);
// });

// // Verificar senha
// bcrypt.compare(process.env.REACT_APP_CRIPTKEY, hashSalvoNoBD, (err, result) => {
//   // result é true se a senha coincidir com o hashSalvoNoBD
//   console.log(result);
// });


// import CryptoJS from 'crypto-js';

// const secretKey = (process.env.REACT_APP_CRIPTKEY); // Chave secreta usada para criptografar e descriptografar

// // Função para gerar a chave a partir da chave secreta
// function generateKey(secret) {
//   return CryptoJS.enc.Utf8.parse(secret);
// }

// // Função para criptografar
// export function encryptPass(plainText) {
//   const key = generateKey(secretKey);
//   const iv = CryptoJS.lib.WordArray.random(16); // Gerar IV aleatório
//   const encrypted = CryptoJS.AES.encrypt(plainText, key, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7
//   });

//   // Concatenar IV com o texto criptografado e codificar em Base64 para armazenamento
//   const cipherText = iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
//   return cipherText;
// }

// // Função para descriptografar
// export function decryptPass(encodedCipherText) {
//   const cipherText = CryptoJS.enc.Base64.parse(encodedCipherText);
//   const iv = cipherText.clone().words.slice(0, 4); // Extrair IV dos primeiros 4 words
//   const encrypted = cipherText.clone().words.slice(4); // Extrair o texto criptografado

//   const key = generateKey(secretKey);
//   const decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.lib.WordArray.create(encrypted) }, key, {
//     iv: CryptoJS.lib.WordArray.create(iv),
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7
//   });

//   const plainText = decrypted.toString(CryptoJS.enc.Utf8);
//   return plainText;
// }


// import CryptoJS from 'crypto-js';

// // Chave secreta usada para criptografar e descriptografar
// const secretKey = (process.env.REACT_APP_CRIPTKEY);  // Certifique-se de que a chave tenha o tamanho correto para AES
// console.log(secretKey);

// // Função para gerar a chave a partir da chave secreta (compatível com Delphi)
// function generateKey(secret) {
//   const key = CryptoJS.enc.Utf8.parse(secret);
//   return key;
// }

// // Função para criptografar
// export function encryptPass(plainText) {
//   const key = generateKey(secretKey);
//   const iv = CryptoJS.lib.WordArray.random(16); // Gerar IV aleatório
//   const encrypted = CryptoJS.AES.encrypt(plainText, key, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7
//   });
//   // Concatenar IV com o texto criptografado e codificar em Base64 para armazenamento
//   const cipherText = CryptoJS.enc.Base64.stringify(iv.concat(encrypted.ciphertext));
//   return cipherText;
// }

// // Função para descriptografar
// export function decryptPass(encodedCipherText) {
//   const cipherText = CryptoJS.enc.Base64.parse(encodedCipherText);
//   const iv = CryptoJS.lib.WordArray.create(cipherText.words.slice(0, 4));
//   const encrypted = CryptoJS.lib.WordArray.create(cipherText.words.slice(4));
//   const key = generateKey(secretKey);
//   const decrypted = CryptoJS.AES.decrypt({ ciphertext: encrypted }, key, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7
//   });
//   const plainText = decrypted.toString(CryptoJS.enc.Utf8);
//   return plainText;
// }


// import CryptoJS from 'crypto-js';

// // Chave secreta usada para criptografar e descriptografar
// const secretKey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRIPTKEY);  // Certifique-se de que a chave tenha o tamanho correto para AES
// const iv = CryptoJS.enc.Utf8.parse('1234567890123456'); // Vetor de Inicialização (IV)

// // Função para criptografar
// export function encryptPass(plainText) {
//   const cipherText = CryptoJS.AES.encrypt(plainText, secretKey, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7
//   }).toString();
//   return cipherText;
// }

// // Função para descriptografar
// export function decryptPass(encodedCipherText) {
//   const bytes = CryptoJS.AES.decrypt(encodedCipherText, secretKey, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7
//   });
//   const plainText = bytes.toString(CryptoJS.enc.Utf8);
//   return plainText;
// }




// import CryptoJS from 'crypto-js';

// // Chave secreta usada para criptografar e descriptografar
// const secretKey = (process.env.REACT_APP_CRIPTKEY);  // Certifique-se de que a chave tenha o tamanho correto para AES

// // Função para criptografar
// export function encryptPass(plainText) {
//   // Criptografa o texto simples usando AES
//   const cipherText = CryptoJS.AES.encrypt(plainText, secretKey).toString();
//   // Codifica o texto criptografado em Base64 para armazenamento
//   return cipherText;
// }

// // Função para descriptografar
// export function decryptPass(encodedCipherText) {
//   // Decodifica o texto criptografado de Base64
//   const bytes = CryptoJS.AES.decrypt(encodedCipherText, secretKey);
//   // Descriptografa o texto criptografado para obter o texto simples original
//   const plainText = bytes.toString(CryptoJS.enc.Utf8);
//   return plainText;
// }

// import CryptoJS from 'crypto-js';

// const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRIPTKEY);  // Chave de 32 bytes
// const iv = CryptoJS.enc.Utf8.parse('your-iv-16bytes');  // IV de 16 bytes

// export function encryptPass(text) {
//   const encrypted = CryptoJS.AES.encrypt(text, key, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7
//   });
//   return encrypted.toString();
// }

// export function decryptPass(encrypted) {
//   const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
//     iv: iv,
//     mode: CryptoJS.mode.CBC,
//     padding: CryptoJS.pad.Pkcs7
//   });
//   return decrypted.toString(CryptoJS.enc.Utf8);
// }



// const crypto = require('crypto');

// const algorithm = process.env.REACT_APP_CRIPTKEY;
// const key = crypto.scryptSync(algorithm, 'salt', 32);
// const iv = crypto.randomBytes(16);

// function encryptPass(text) {
//   const cipher = crypto.createCipheriv(algorithm, key, iv);
//   let encrypted = cipher.update(text, 'utf8', 'hex');
//   encrypted += cipher.final('hex');
//   return iv.toString('hex') + ':' + encrypted;
// }

// function decryptPass(encrypted) {
//   const textParts = encrypted.split(':');
//   const iv = Buffer.from(textParts.shift(), 'hex');
//   const encryptedText = textParts.join(':');
//   const decipher = crypto.createDecipheriv(algorithm, key, iv);
//   let decrypted = decipher.update(encryptedText, 'hex', 'utf8');
//   decrypted += decipher.final('utf8');
//   return decrypted;
// }

// // Testando a função
// const plainText = 'Hello, world!';
// const encryptedText = encryptPass(plainText);
// console.log('Encrypted:', encryptedText);

// const decryptedText = decryptPass(encryptedText);
// console.log('Decrypted:', decryptedText);
